import React from "react";
import { Link } from "react-router-dom";
import { currency } from "../../App";

const Item = (props) => {

  const slugify = (text) =>
  text
    .toLowerCase()
    .replace(/\s+/g, "-")        
    .replace(/[^\w\-]+/g, "")   
    .replace(/\-\-+/g, "-")     
    .replace(/^-+/, "")         
    .replace(/-+$/, "");        

  return (
    <div className="bg-white w-full max-w-[98%] shadow mt-6 transition-shadow duration-300 overflow-hidden h-auto flex flex-col rounded-[10px]">
      <Link to={`/product/${props.id}/${slugify(props.name)}`} onClick={() => window.scrollTo(0, 0)}>
        {/* Square container for mobile, fixed height for desktop */}
        <div className="overflow-hidden aspect-square sm:h-[400px] flex items-center justify-center">
          <img crossOrigin="anonymous" 
            src={props.image}
            alt={props.name}
             loading="lazy"
            className="hover:scale-105 transition-transform duration-300 object-cover w-full h-full"
          />
        </div>
      </Link>
      <div className="p-3 sm:p-4 flex-grow flex flex-col justify-between">
        {/* Product Name */}
        <p className="text-xs sm:text-sm md:text-base font-medium mt-1 sm:mt-2 truncate">
          {props.name}
        </p>

        {/* Price Info */}
        <div className="flex flex-wrap gap-1 sm:gap-2 mt-1 sm:mt-2 items-center">
          {/* Current Price */}
          <div className="text-xs sm:text-sm md:text-base font-semibold text-purple-600">
            From {currency}{props.new_price}
          </div>

          {/* Original Price */}
          <div className="text-[10px] sm:text-xs md:text-sm text-gray-500 line-through">
            {currency}{props.old_price}
          </div>

          {/* Discount Percentage */}
          <div className="text-[10px] sm:text-xs md:text-sm text-green-500 bg-green-100 px-1.5 sm:px-2 py-0.5 rounded-full">
            {props.discountPercentage}% OFF
          </div>
        </div>
      </div>
    </div>
  );
};

export default Item;
